import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  host: { style: 'display: contents' },
  templateUrl: './avatar.component.html',
})
export class AppAvatarComponent {
  @Input() url: string | null | undefined = '';
  @Input() name: string | null | undefined = '';
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | null | undefined = 'md';

  failedImage = signal(false);

  onImageError(): void {
    this.failedImage.set(true);
  }

  getInitial(): string {
    return this.name ? this.name.charAt(0).toUpperCase() : '?';
  }

  sizeClasses(): string {
    switch (this.size) {
      case 'sm':
        return 'w-6 h-6 text-xs';
      case 'md':
        return 'w-10 h-10 text-lg';
      case 'lg':
        return 'w-12 h-12 text-lg';
      case 'xl':
        return 'w-14 h-14 text-xl';
      case '2xl':
        return 'w-20 h-20 text-4xl';
      default:
        return 'w-8 h-8 text-sm';
    }
  }
}
